import {SecureService} from "@/services/superclasses/secure-service";
import {Status} from "@/interfaces/status";
import {Person} from "@/interfaces/person";
import {PersonManage} from "@/interfaces/person-manage";
import {FormResponse} from "@/interfaces/form-response";

const api = window.contextPath + '/rest/persons';

export class PersonSecureService extends SecureService {

    public manage = async (id: number): Promise<PersonManage> => {
        return this.data(await this.get<PersonManage>(`${api}/${id}/manage`));
    };

    public update = async (id: number, data: PersonManage): Promise<FormResponse<PersonManage>> => {
        return this.data(await this.put<FormResponse<PersonManage>>(`${api}/${id}`, data));
    };

    public logout = async (): Promise<void> => {
        return this.data(await this.post<void>(api + "/logout"));
    }

    public loadByMember = async (args: {
        orderBy?: number,
        first?: number,
        max?: number
    }): Promise<Person[]> => {
        return this.data(await this.get<Person[]>(api + "/by-member",
            {
                params: args
            }))
    }

    public countByMember = async (): Promise<number> => {
        return this.data(await this.get<number>(api + "/count-by-member"))
    }

    public removeByMember = async (personId: number): Promise<void> => {
        return this.data(await this.delete<void>(api + "/by-member/" + personId));
    }

    public switchMember = async (id: number): Promise<Status> => {
        return this.data(await this.put<Status>(api + "/switch-member/" + id,));
    }

    public resendActivation = async (personId: number): Promise<FormResponse<void>> => {
        return this.data(await this.post(`${api}/resend-activation-email/${personId}`))
    }
}

export const personSecureService = new PersonSecureService();